import {
  descriptionUI,
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { SecondayCaregiverOneIntro } from '../../../components/FormDescriptions/SecondayCaregiverIntros';
import content from '../../../locales/en/content.json';
import { hasPrimaryCaregiver } from '../../../utils/helpers';
import { validateCaregivers } from '../../../utils/validation';

const TITLE_TEXT = content['secondary-info-title--apply'];
const INPUT_LABEL = content['secondary-one-apply-label'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...descriptionUI(SecondayCaregiverOneIntro),
    'view:hasSecondaryCaregiverOne': {
      ...yesNoUI({
        title: INPUT_LABEL,
        required: hasPrimaryCaregiver,
      }),
      'ui:validations': [validateCaregivers],
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:hasSecondaryCaregiverOne': yesNoSchema,
    },
  },
};
